<!-- src/views/TakeAway.vue -->
<!-- Take Away & Delivery page - Full window Flipdish ordering widget -->
<template>
  <div class="fixed inset-0 z-50 bg-white">
    <!-- Exit Button Bar -->
    <div
      class="bg-pb py-3 px-4 flex items-center justify-between shadow-md relative z-[100]"
    >
      <span class="text-white font-medium text-sm sm:text-base"
        >Take Away & Delivery</span
      >
      <a
        href="/"
        class="rl flex items-center px-3 py-2 sm:px-4 bg-sg text-pb font-medium rounded hover:bg-opacity-80 transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 sm:mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        <span class="hidden sm:inline">Back to Website</span>
        <span class="sm:hidden ml-1">Exit</span>
      </a>
    </div>

    <!-- Flipdish Widget - Full remaining space -->
    <div class="h-[calc(100vh-60px)] overflow-auto">
      <FlipdishWidget :key="widgetKey" />
    </div>
  </div>
</template>

<script>
import FlipdishWidget from "@/components/flipdish/Widget.vue";

export default {
  name: "TakeAway",
  components: {
    FlipdishWidget,
  },
  data() {
    return {
      // Unique key to force widget re-mount on each navigation
      widgetKey: Date.now(),
    };
  },
  activated() {
    // Update key when component is activated (for keep-alive scenarios)
    this.widgetKey = Date.now();
  },
};
</script>

<style></style>
